import log from '@vcclive/log';
import { applyMiddleware, createStore, Reducer, Store } from 'redux';
import { Action, SagaBuilder } from '../interfaces/redux';
import { errorMiddleware } from './errorReporter';
import { createSagaMiddleware } from './vcc-saga';

const debug = log.getDebug('store');

export function configureStore<S>(reducer: Reducer<S>, saga: SagaBuilder<S>): Store<S> {
    debug('init');
    const enhancer = applyMiddleware(
        errorMiddleware,
        createSagaMiddleware<S>(saga),
    );
    return createStore<S, Action, unknown, typeof enhancer>(reducer, enhancer);
}
